module.exports = __webpack_public_path__ + "img/role4.63410a34.png";